import { v4 as uuidv4 } from "uuid";
import { plainToClass } from "class-transformer";
import ChargePriceListResponse from "entities/chargePriceListResponse";

const SESSION_STORAGE_PRICE_LIST_KEY = "price_list";

export default class ChargePriceListStorageRepository {
  addPriceList(priceList: ChargePriceListResponse) {
    if (!!priceList && !priceList?.id) {
      priceList.id = uuidv4();
    }

    const priceListString = sessionStorage.getItem(SESSION_STORAGE_PRICE_LIST_KEY);
    if (priceListString) {
      this.removePriceList();
    }
    sessionStorage.setItem(SESSION_STORAGE_PRICE_LIST_KEY, JSON.stringify(priceList));
  }

  getPriceList() {
    let priceList: ChargePriceListResponse;
    const priceListString = sessionStorage.getItem(SESSION_STORAGE_PRICE_LIST_KEY);
    if (priceListString) {
      priceList = JSON.parse(priceListString) as ChargePriceListResponse;
      return plainToClass(ChargePriceListResponse, priceList);
    }
  }

  removePriceList() {
    this.clearPriceList();
  }

  storePriceList(priceList: ChargePriceListResponse[]) {
    sessionStorage.setItem(SESSION_STORAGE_PRICE_LIST_KEY, JSON.stringify(priceList));
  }

  async clearPriceList() {
    sessionStorage.removeItem(SESSION_STORAGE_PRICE_LIST_KEY);
  }
}
